<script setup lang="ts">
    import { Button } from '~/components/ui/button'
    
    const modelValue = defineModel<boolean>('modelValue', {
        default: false
    })
    
    const props = defineProps({
        icon: {
            type: String,
        },
        label: {
            type: String,
            default: null
        }
    })
    
    function handleToggle() {
        modelValue.value = !modelValue.value
    }

    const checked = computed(() => {
        return modelValue.value
    })

    defineExpose({
        checked
    })
</script>
    
<template>
    <Button
        variant="lighter"
        @click="handleToggle"
        class="text-black font-normal gap-2 flex items-center justify-between px-3 py-4 h-auto"
        :class="{
            'bg-primary-500 hover:bg-primary-600 hover:text-white text-white': modelValue,
        }"
    >
        <div>
            <slot :checked="checked">
                {{ label}}
            </slot>
        </div>
        <div 
            class="w-4 h-4 rounded-full flex items-center justify-center shrink-0 transition-colors"
            :class="{
                'bg-gray-200 border-2 border-gray-300': !modelValue,
                'bg-white': modelValue
            }"
        >
            <Icon 
                v-if="modelValue" 
                name="ri:check-line" 
                class="text-primary-500"
                size="12"
            />
        </div>
    </Button>
</template>